<template>
  <form class="user-block">
    <div v-if="!queryChangeCode" class="">
      <div class="user-block__title">Что-то пошло не так...</div>
      <div class="user-block__text">Вы можете обратиться за помощью к аутсорсеру.</div>
    </div>

    <div v-if="queryChangeCode && statusBlock === 'outdated'" class="">
      <div class="user-block__title">Срок действия ссылки истек</div>
      <div class="user-block__text">Вы можете обратиться за помощью к аутсорсеру.</div>
    </div>

    <div v-if="queryChangeCode && statusBlock === 'blocked'" class="">
      <img class="user-block__icon-check" src="@icons/chat/check-circle-filled.svg" />
      <div class="user-block__title">Ваш аккаунт успешно заблокирован</div>
      <div class="user-block__text">После восстановления доступа рекомендуем изменить пароль для входа.</div>
    </div>

    <div v-if="queryChangeCode && statusBlock === 'ok'" class="">
      <img class="user-block__img" src="@icons/user-block.svg" alt="logo.svg" />

      <div class="user-block__title">Ваша почта отключена от сервиса 1С:БухОбслуживание</div>
      <div class="user-block__text">
        Если это действие совершено не Вами или не по Вашей просьбе, вы можете заблокировать свой аккаунт — доступ к
        сервису будет заблокирован, все сеансы будут завершены.
      </div>
      <div class="user-block__text">
        После блокировки обратитесь к своему аутсорсеру для изменения данных и восстановления доступа к сервису.
      </div>

      <ButtonWithLoader :is-blocked="isBlockLoading" class="user-block__btn" @click="doBlock()">
        Заблокировать аккаунт
      </ButtonWithLoader>
    </div>
  </form>
</template>

<script>
import { mapActions } from "vuex";
import ButtonWithLoader from "../../components/common/ButtonWithLoader.vue";

export default {
  name: "UserBlock",

  components: {
    ButtonWithLoader,
  },

  data() {
    return {
      statusBlock: "",
      queryChangeCode: "",
      isBlockLoading: false,
    };
  },

  async created() {
    this.queryChangeCode = this.$route.query["change-code"];

    if (this.queryChangeCode) {
      const user = await this.fetchUser({ code: this.queryChangeCode });
      this.statusBlock = user?.status_block || "";
    }
  },

  methods: {
    ...mapActions({
      fetchUser: "User/Settings/fetchUser",
      confirmUserBlock: "User/Settings/confirmUserBlock",
    }),

    async doBlock() {
      this.isBlockLoading = true;

      try {
        await this.confirmUserBlock(this.queryChangeCode);

        window.location.reload();
      } catch (error) {
        this.$notify({
          type: "error",
          text: error?.response?.data?.error || error?.response?.data?.message || error.message,
        });
      } finally {
        this.isBlockLoading = false;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.user-block {
  display: flex;
  width: 430px;
  max-width: 96%;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;

  &__title {
    margin-bottom: 20px;
    color: #1c1c1c;
    font-size: 24px;
    font-weight: 500;
    line-height: 130%;
  }

  &__text {
    margin-bottom: 20px;
    color: #848484;
    font-size: 15px;
    font-weight: 400;
    line-height: 120%;
  }

  &__icon-check {
    width: 100px;
    margin-bottom: 40px;
  }

  &__img {
    margin-bottom: 40px;
  }

  &__btn {
    max-width: 332px;
    margin: 0 auto;
    margin-top: 20px;
  }
}
</style>
